import React, { forwardRef } from 'react';
import clsx from 'clsx';

interface PanelProps extends React.PropsWithChildren {
  className?: string;
  bgColorClassName?: string;
}

export const Panel = forwardRef<HTMLDivElement, PanelProps>(
  ({ children, className, bgColorClassName = 'bg-white' }, ref) => (
    <div
      ref={ref}
      className={clsx(
        'p-3 md:p-4 rounded-2xl box-border',
        bgColorClassName,
        className,
      )}
    >
      {children}
    </div>
  ),
);

Panel.displayName = 'Panel';
